// Per-src image cache for pill icons. onReady fires once the image loads so the pill repaints.

type CacheEntry = { img: HTMLImageElement; ready: boolean };

const cache = new Map<string, CacheEntry>();
const subscribers = new Map<string, Set<() => void>>();

/** Returns the loaded image, or null while still loading. */
export function getCachedImage(src: string, onReady?: () => void): HTMLImageElement | null {
  if (!src) return null;

  const cached = cache.get(src);
  if (cached?.ready) return cached.img;

  if (onReady) {
    if (!subscribers.has(src)) subscribers.set(src, new Set());
    subscribers.get(src)!.add(onReady);
  }

  if (cached) return null;

  const img = new Image();
  img.crossOrigin = 'anonymous';
  cache.set(src, { img, ready: false });

  img.onload = () => {
    const entry = cache.get(src);
    if (entry) entry.ready = true;
    subscribers.get(src)?.forEach(cb => cb());
    subscribers.delete(src);
  };
  img.onerror = () => {
    cache.delete(src);
    subscribers.delete(src);
  };
  img.src = src;

  return null;
}
